"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const deleteContact_1 = __importDefault(require("./deleteContact"));
const deleteContactCommentary_1 = __importDefault(require("./deleteContactCommentary"));
const deleteContactEmployee_1 = __importDefault(require("./deleteContactEmployee"));
const getContactActivity_1 = __importDefault(require("./getContactActivity"));
const getContactDuplicate_1 = __importDefault(require("./getContactDuplicate"));
const getContactOrderBalanceHighlight_1 = __importDefault(require("./getContactOrderBalanceHighlight"));
const getContactShipmentCommissionHighlight_1 = __importDefault(require("./getContactShipmentCommissionHighlight"));
const getContactPrefill_1 = __importDefault(require("./getContactPrefill"));
const getContact_1 = __importDefault(require("./getContact"));
const getContactShares_1 = __importDefault(require("./getContactShares"));
const getContactShipmentBalanceHighlight_1 = __importDefault(require("./getContactShipmentBalanceHighlight"));
const getContactShipmentsHighlight_1 = __importDefault(require("./getContactShipmentsHighlight"));
const getContactTags_1 = __importDefault(require("./getContactTags"));
const postContact_1 = __importDefault(require("./postContact"));
const postContactAvatar_1 = __importDefault(require("./postContactAvatar"));
const postContactCommentary_1 = __importDefault(require("./postContactCommentary"));
const postContactEmployee_1 = __importDefault(require("./postContactEmployee"));
const postContactEmployeeMatchQuery_1 = __importDefault(require("./postContactEmployeeMatchQuery"));
const postContactEmployeeSuggestQuery_1 = __importDefault(require("./postContactEmployeeSuggestQuery"));
const postContactMatchQuery_1 = __importDefault(require("./postContactMatchQuery"));
const postContactShares_1 = __importDefault(require("./postContactShares"));
const postContactSuggestQuery_1 = __importDefault(require("./postContactSuggestQuery"));
const putContact_1 = __importDefault(require("./putContact"));
const putContactCommentary_1 = __importDefault(require("./putContactCommentary"));
const putContactEmployee_1 = __importDefault(require("./putContactEmployee"));
const createContactClient = (axios) => ({
    deleteContact: ({ contactId }) => deleteContact_1.default({ axios, contactId }),
    deleteContactCommentary: ({ contactId, commentaryId }) => deleteContactCommentary_1.default({ axios, contactId, commentaryId }),
    deleteContactEmployee: ({ contactId, employeeId }) => deleteContactEmployee_1.default({ axios, contactId, employeeId }),
    getContact: ({ contactId }) => getContact_1.default({ axios, contactId }),
    getContactActivity: ({ contactId }) => getContactActivity_1.default({ axios, contactId }),
    getContactDuplicate: ({ ico, dic }) => getContactDuplicate_1.default({ axios, ico, dic }),
    getContactOrderBalanceHighlight: ({ contactId, currency, period, timeZone, range }) => getContactOrderBalanceHighlight_1.default({
        axios,
        contactId,
        currency,
        period,
        timeZone,
        range
    }),
    getContactShipmentCommissionHighlight: ({ contactId, currency, period, timeZone, range }) => getContactShipmentCommissionHighlight_1.default({
        axios,
        contactId,
        currency,
        period,
        timeZone,
        range
    }),
    getContactPrefill: ({ ico, dic }) => getContactPrefill_1.default({ axios, ico, dic }),
    getContactShares: ({ contactId }) => getContactShares_1.default({ axios, contactId }),
    getContactShipmentBalanceHighlight: ({ contactId, currency, period, timeZone, range }) => getContactShipmentBalanceHighlight_1.default({
        axios,
        contactId,
        currency,
        period,
        timeZone,
        range
    }),
    getContactShipmentsHighlight: ({ contactId, period, timeZone, range }) => getContactShipmentsHighlight_1.default({
        axios,
        contactId,
        period,
        timeZone,
        range
    }),
    getContactTags: () => getContactTags_1.default({ axios }),
    postContact: ({ contact }) => postContact_1.default({ axios, contact }),
    postContactAvatar: ({ contactId, avatarFile }) => postContactAvatar_1.default({ axios, contactId, avatarFile }),
    postContactCommentary: ({ contactId, commentary }) => postContactCommentary_1.default({ axios, contactId, commentary }),
    postContactEmployee: ({ contactId, employee }) => postContactEmployee_1.default({ axios, contactId, employee }),
    postContactEmployeeMatchQuery: ({ contactId, query }) => postContactEmployeeMatchQuery_1.default({ axios, contactId, query }),
    postContactEmployeeSuggestQuery: ({ contactId, query }) => postContactEmployeeSuggestQuery_1.default({ axios, contactId, query }),
    postContactMatchQuery: ({ query }) => postContactMatchQuery_1.default({ axios, query }),
    postContactShares: ({ contactId, shares }) => postContactShares_1.default({ axios, contactId, shares }),
    postContactSuggestQuery: ({ query }) => postContactSuggestQuery_1.default({ axios, query }),
    putContact: ({ contactId, contact }) => putContact_1.default({ axios, contactId, contact }),
    putContactCommentary: ({ contactId, commentaryId, commentary }) => putContactCommentary_1.default({
        axios,
        contactId,
        commentaryId,
        commentary
    }),
    putContactEmployee: ({ contactId, employeeId, employee }) => putContactEmployee_1.default({
        axios,
        contactId,
        employeeId,
        employee
    })
});
exports.default = createContactClient;
